import React from 'react';
import Container from 'react-bootstrap/Container';
import Slider from "react-slick";
import './Partners.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CompanyJobfairInfo, stallMap } from '../stallMapData_2026';

type PartnerLogo = {
  src: string;
  alt: string;
  companyName: string;
};

const createCompanyNumbers = (map: Map<number, CompanyJobfairInfo>): { [key: string]: number | string } => {
  const companyNumbers: { [key: string]: number | string } = {};

  map.forEach((companyInfo) => {
    if (companyInfo.stallNumber !== null) {
      companyNumbers[companyInfo.companyName] = companyInfo.stallNumber;
    } else {
      companyNumbers[companyInfo.companyName] = 0;
    }
  });

  return companyNumbers;
};

const companyNumbers = createCompanyNumbers(stallMap);

const plusPartners: PartnerLogo[] = [
  { src: "/data/logos/plus/abb_white.png", alt: "ABB", companyName: "ABB" },
  { src: "/data/logos/plus/akkodis_white.png", alt: "Akkodis", companyName: "Akkodis" },
  { src: "/data/logos/plus/konplan_white.png", alt: "KONPLAN", companyName: "KONPLAN" },
  { src: "/data/logos/plus/valeo_rgb.png", alt: "Valeo", companyName: "Valeo" },
  { src: "/data/logos/plus/vinci_white.png", alt: "VINCI", companyName: "VINCI" },
  { src: "/data/logos/plus/FOSFA_logo.png", alt: "Fosfa a.s.", companyName: "Fosfa a.s." },
];

const standardPartners: PartnerLogo[] = [
  { src: "/data/logos/standard/ceps_white.png", alt: "ČEPS", companyName: "ČEPS, a.s." },
  { src: "/data/logos/standard/plzen_white.png", alt: "Plzeň", companyName: "Plzeň" },
  { src: "/data/logos/standard/procter_white.png", alt: "Procter", companyName: "Procter" },
  { src: "/data/logos/standard/ujv_white.png", alt: "ÚJV Řež", companyName: "ÚJV Řež, a. s." },
];

const getPartnerHref = (companyName: string) => {
  const companyNumberValue = companyNumbers[companyName] ?? companyNumbers["IAESTE LC Brno"] ?? 0; // Default to 0 if company name is not found
  return `/plan?number=${companyNumberValue}`;
};

const renderPartnerLogo = (partner: PartnerLogo) => (
  <div key={partner.src}>
    <a href={getPartnerHref(partner.companyName)}>
      <img className="partner-logo" src={partner.src} alt={partner.alt} />
    </a>
  </div>
);

function Partners() {
  const plusSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const standardSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div>
      <div className="">
        <Container className="partner-container" fluid>
          <div className="small-box plus-partner-box"> <div className="partners-text"> Partneři Plus </div>
            <Slider {...plusSettings}>
              {plusPartners.map(renderPartnerLogo)}
            </Slider>
          </div>

          <div className="middle-box media-partner-box">
            <div className="partners-text"> Mediální partner </div>
            <div className="logo-center">
              <a href={getPartnerHref("Lenovo")}>
                <img className="partner-logo" src="/data/logos/Lenovo_white.png" alt="Lenovo" />
              </a>
            </div>
          </div>

          <div className="middle-box general-partner-box">
            <div className="partners-text"> Generální partner </div>
            <div className="logo-center">
              <a href={getPartnerHref("ČEZ, a.s.")}>
                <img className="partner-logo" src="/data/logos/general/skupina_cez_white.png" alt="ČEZ" />
              </a>
            </div>
          </div>

          <div className="middle-box support-partner-box">
            <div className="partners-text"> Za podpory </div>
            <div className="logo-center">
              <a href={getPartnerHref("VUT")}>
                <img className="partner-logo" src="/data/logos/VUT_white.png" alt="VUT" />
              </a>
            </div>
          </div>

          <div className="small-box standard-partner-box"> <div className="partners-text"> Partneři Standard </div>
            <Slider {...standardSettings}>
              {standardPartners.map(renderPartnerLogo)}
            </Slider>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default Partners;
